<script lang="ts" setup>
import type { SubjectCode, SubjectViewProps } from '~/models/Subject'
import { computed, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import useProductStore from '~/stores/product'
import { useAppColor } from '~/composables/useAppColor'
import LegacySubjectView from '~/components/subject/LegacySubjectView.vue'

const props = defineProps<{ subjectCode: SubjectCode }>()

const { hasLoaded } = storeToRefs(useProductStore())
const { clear: clearAppColor } = useAppColor()

onBeforeUnmount(() => {
  clearAppColor()
})

const componentProps = computed((): SubjectViewProps => ({
  subjectCode: props.subjectCode,
  isUpcoming: false,
  isArchive: true,
}))
</script>

<template>
  <LegacySubjectView
    v-if="hasLoaded"
    v-bind="componentProps"
  />
</template>
